import React from "react";
import { Box } from "@mui/material";
import Header from "src/components/Header";

export type LayoutPrincipalProps = {
  children: React.ReactNode;
};

function LayoutPrincipal({ children }: LayoutPrincipalProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
      data-testid="layout-principal"
    >
      <Header />
      <Box
        sx={{
          width: "100%",
          minHeight: "100%",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white"
        }}
      >
        <div className="container">{children}</div>
      </Box>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#f5f5f5",
          padding: 2,
          textAlign: "center",
        }}
      >
        <p>© 2025 Facultad de Ingeniería | Universidad de Antioquia. Todos los derechos reservados.</p>
        <p style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          Soporte técnico:{" "}
          <p style={{  cursor: "pointer", textDecoration: "underline", color: "#007bff" }}>
            operacion@talentotech2.com.co
          </p>
        </p> 
        </Box>
    </Box>
  );
}

export default LayoutPrincipal;
